import EditarContaCaixinhaModal from './EditarContaCaixinhaModal';

export default EditarContaCaixinhaModal;
